"use strict";

exports["default"] = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

exports.__esModule = true;


//////////////////
// WEBPACK FOOTER
// /~/react-bootstrap-validation/~/babel-runtime/helpers/class-call-check.js
// module id = 216
// module chunks = 0